import { Pipe, PipeTransform } from '@angular/core';
import { StatusTagColorEnum, SummaryStatusEnum } from '@models/tag';

const summaryStatusTagMap: Record<SummaryStatusEnum, { label: string; color: StatusTagColorEnum; icon: string }> = {
  [SummaryStatusEnum.DONE]: {
    label: 'Terminé',
    color: StatusTagColorEnum.LIGHT_GREEN,
    icon: 'file-check-alt',
  },
  [SummaryStatusEnum.PROCESSING]: {
    label: 'En cours',
    color: StatusTagColorEnum.LIGHT_BLUE,
    icon: 'comment-exclamation',
  },
  [SummaryStatusEnum.CANCEL]: {
    label: 'Annulé',
    color: StatusTagColorEnum.LIGHT_RED,
    icon: 'cross',
  },
  [SummaryStatusEnum.TO_BE_STARTED]: {
    label: 'À traiter',
    color: StatusTagColorEnum.LIGHT_YELLOW,
    icon: 'comment-exclamation',
  },
};

/**
 * Gets tag information from a client Algolia hit.
 */
@Pipe({
  name: 'clientTag',
  standalone: true,
})
export class ClientTagPipe implements PipeTransform {
  transform(hit: any): { label: string; color: string; icon: string } | null {
    const status = hit.orderSummaryStatus as SummaryStatusEnum;

    if (!status || !summaryStatusTagMap[status]) {
      return null;
    }

    return {
      label: summaryStatusTagMap[status].label,
      color: summaryStatusTagMap[status].color,
      icon: summaryStatusTagMap[status].icon,
    };
  }
}
